import { render, staticRenderFns } from "./serverRoleList.vue?vue&type=template&id=6b720c14&"
import script from "./serverRoleList.vue?vue&type=script&lang=js&"
export * from "./serverRoleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b720c14')) {
      api.createRecord('6b720c14', component.options)
    } else {
      api.reload('6b720c14', component.options)
    }
    module.hot.accept("./serverRoleList.vue?vue&type=template&id=6b720c14&", function () {
      api.rerender('6b720c14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/serverRoleList.vue"
export default component.exports